export interface Package {
  id: string;
  tickets: number;
  bonus: number;
  price: number;
  pricePerTicket: number;
  badge?: string;
  badgeColor?: string;
  secondaryLightColor: string;
  popular: boolean;
}

interface PackageCardProps {
  pkg: Package;
  onSelect: (pkg: Package) => void;
}

export default function PackageCard({ pkg, onSelect }: PackageCardProps) {
  const totalTickets = pkg.tickets + pkg.bonus;

  return (
    <div
      className={`relative bg-white rounded-2xl border-2 flex flex-col items-center text-center gap-4 p-5 transition-all duration-300 hover:-translate-y-1.5 cursor-pointer
        ${pkg.popular ? `${pkg.secondaryLightColor.replace("text-", "border-")} shadow-xl scale-105` : "border-slate-200 hover:border-slate-300 shadow-sm hover:shadow-md"}`}
      onClick={() => onSelect(pkg)}
    >
      {/* Badge */}
      {pkg.badge && (
        <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 z-10">
          <span className={`${pkg.badgeColor} text-white text-[10px] font-bold px-3 py-1 rounded-full whitespace-nowrap shadow`}>
            {pkg.badge}
          </span>
        </div>
      )}

      {/* Ticket count */}
      <div className="flex flex-col items-center gap-0.5 pt-1">
        <span className={`font-playfair font-bold leading-none ${pkg.popular ? pkg.secondaryLightColor : "text-slate-900"}`}
          style={{ fontSize: totalTickets >= 100 ? "2.6rem" : "3rem" }}>
          {totalTickets}
        </span>
        <span className="text-slate-400 text-xs font-medium uppercase tracking-widest">Lose</span>
        {pkg.bonus > 0 && (
          <span className="bg-emerald-100 text-emerald-700 text-[10px] font-bold px-2 py-0.5 rounded-full mt-1 whitespace-nowrap">
            +{pkg.bonus} gratis
          </span>
        )}
      </div>

      {/* Divider */}
      <div className="w-8 h-px bg-slate-200"></div>

      {/* Price */}
      <div className="flex flex-col items-center gap-0.5">
        <div className="flex items-end gap-0.5">
          <span className="font-bold text-slate-900 text-2xl leading-none">{pkg.price}</span>
          <span className="text-slate-500 text-base font-semibold mb-0.5">€</span>
        </div>
        <span className="text-slate-400 text-[10px]">{pkg.pricePerTicket.toFixed(2)} € / Los</span>
      </div>

      {/* CTA */}
      <button
        onClick={(e) => { e.stopPropagation(); onSelect(pkg); }}
        className={`w-full font-bold py-2.5 rounded-xl transition-all duration-200 cursor-pointer text-xs whitespace-nowrap mt-auto
          ${pkg.popular
            ? `bg-primary hover:bg-primary-dark text-white shadow-md`
            : "bg-slate-900 hover:bg-slate-800 text-white"}`}
      >
        Wählen
      </button>
    </div>
  );
}
